module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Отказ"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Публикувай"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "topic_title",
      "errors": _vm.errorBag.collect('topic_title')
    },
    model: {
      value: (_vm.topic.title),
      callback: function($$v) {
        _vm.$set(_vm.topic, "title", $$v)
      },
      expression: "topic.title"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "topic_section",
      "values": _vm.sectionValues,
      "errors": _vm.errorBag.collect('topic_section')
    },
    model: {
      value: (_vm.topic.section),
      callback: function($$v) {
        _vm.$set(_vm.topic, "section", $$v)
      },
      expression: "topic.section"
    }
  }), _vm._v(" "), (_vm.topic.text !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('f-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "name": "topic_text",
      "errors": _vm.errorBag.collect('topic_text'),
      "crows": 10
    },
    model: {
      value: (_vm.topic.text),
      callback: function($$v) {
        _vm.$set(_vm.topic, "text", $$v)
      },
      expression: "topic.text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Преглед")]), _vm._v(" "), _c('vue-markdown', {
    attrs: {
      "source": _vm.topic.text
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1) : _vm._e()], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_vm._v("\n\t\t\t\t\t\tМоже да форматирате съобщението си като използвате "), _c('a', {
    attrs: {
      "href": "http://commonmark.org/help/",
      "target": "_blank"
    }
  }, [_vm._v("markdown")]), _vm._v(".\n\t\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06b5066c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/forum/TopicEdit.vue
// module id = 634
// module chunks = 1